import { Box, Card, Container, Image, Wrap } from "@chakra-ui/react";
import { FooterCredits, FooterOrganizzatori, Signature } from "../../atoms";
import { useSelector } from "react-redux";
import { getSponsorData } from "../../../store/sponsor/selectors";

export default function Footer() {
  const sponsors = useSelector(getSponsorData);

  return (
    <Box className="footer">
      <Container maxW="6xl" my="70">
        <FooterOrganizzatori />

        {sponsors?.some((sponsor) => sponsor.isSponsor && sponsor.show) && (
          <Card>
            <Wrap p="10px" justify="center" spacing="10px">
              {sponsors?.map((sponsor) =>
                sponsor.isSponsor && sponsor.show ? (
                  <Image
                    src={sponsor.logoUrl}
                    maxHeight="100px"
                    key={sponsor.name}
                  />
                ) : (
                  <></>
                ),
              )}
            </Wrap>
          </Card>
        )}
      </Container>
      <FooterCredits />
      <Signature />
    </Box>
  );
}
